import React from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Table, Button, Header, Segment } from 'semantic-ui-react'
import moment from 'moment'
import styled from 'styled-components'

import FormatDateTime from './components/FormatDateTime'
import DateField from './components/DateRangeField'
import LuckyDrawWinnerActions from '../../reducers/luckyDrawWinnerReducer'
import Loading from '../../components/common/loading'

const HeaderWrapper = styled.div`
  margin-bottom: 14px
  padding: 0 14px
`

class LuckyDrawWinners extends React.PureComponent{
  state = {
    startFrom: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('day')
        .format('x')
    ),
    loadingIds: [],
  }

  componentDidMount(){
    const {getLuckyDrawWinners, setLoading} = this.props
    const { startFrom, endAt} = this.state
    setLoading()
    getLuckyDrawWinners({startFrom, endAt})
  }

  onFieldChange = (field, value) => {

    this.setState({ [field]: value })
  }

  getLuckyDrawWinnerByDate = () => {
    const { getLuckyDrawWinners } = this.props
    const { startFrom, endAt } = this.state

    getLuckyDrawWinners({startFrom, endAt})
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getLuckyDrawWinnerByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onClaimed = async (winner) => {
    try {
      const { setSingleClaimed, user } = this.props

      await this.setStateAsync(({ loadingIds }) => ({ loadingIds: loadingIds.concat(winner.id) }))

      const winnerRef = firebase.firestore().collection('lucky_draw_winners')
      const now = Number(moment().format('x'))

      const updates = {
        claimed: true,
        updated_at: now,
        handler: user.username,
      }

      const data = { ...winner, claimed: true, updated_at: now, handler: user.username }

      const confirmation = window.confirm('Are you sure to claim this winner?')
      const setState = ({ loadingIds }) => ({ loadingIds: loadingIds.filter(id => id !== winner.id) })

      if(confirmation) {
        await winnerRef.doc(winner.id).update(updates)
        await this.setStateAsync(setState)
        setSingleClaimed({ data })
      }

      return await this.setStateAsync(setState)

    } catch(e) {
      alert(e.message)
    }
  }

  renderRow = (winner, index) => {
    const { loadingIds } = this.state
    const {
      id,
      handler,
      claimed,
      created_at: createdAt,
      updated_at: updatedAt,
      phone_number: phoneNumber,
      deliveree_name: delivereeName,
    } = winner

    const claimLoading = loadingIds.includes(id)

    return (
      <Table.Row key={id}>
        <Table.Cell>{index+1}</Table.Cell>
        <Table.Cell>{delivereeName}</Table.Cell>
        <Table.Cell textAlign="center">{phoneNumber}</Table.Cell>
        <Table.Cell textAlign="center">
          <FormatDateTime timeStamp={createdAt} />
        </Table.Cell>
        <Table.Cell textAlign="center">
          {claimed ? <FormatDateTime timeStamp={updatedAt} /> : '---'}
        </Table.Cell>
        <Table.Cell textAlign="center">
          {claimed ? (
            `${handler}`
          ) : (
            <Button
              size="mini"
              content="Claim Now"
              loading={claimLoading}
              disabled={claimLoading}
              onClick={() => this.onClaimed(winner)}
            />
          )}
        </Table.Cell>
      </Table.Row>
    )
  }

  renderNoDataRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={6} textAlign="center">
          No Data available
        </Table.Cell>
      </Table.Row>
    )
  }

  render(){
    const { startFrom, endAt } = this.state
    const { winnerLoading, winners, loading } = this.props

    return (
      <div>
        <Loading active={loading} />
        <Segment color="black">
          <HeaderWrapper>
            <Header size="large" style={{ display: 'inline-block' }}>
              Lucky Draw Winners <strong>({winners.length})</strong>
            </Header>
          </HeaderWrapper>
          <div style={{ padding: '0px 14px' }}>
            <DateField
              loading={winnerLoading}
              startFrom={startFrom}
              endAt={endAt}
              onSearch={this.onSearch}
              onFieldChange={this.onFieldChange}
            />
          <div style={{ marginBottom: 15 }} />
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>No</Table.HeaderCell>
                  <Table.HeaderCell>Customer Name</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Phone</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Created At</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Claimed At</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {winners.length > 0 ? winners.map(this.renderRow) : this.renderNoDataRow()}
              </Table.Body>
            </Table>
          </div>
        </Segment>
      </div>
    )
  }
}

const mapState = ({ auth, luckyDrawWinners }) => ({
  user: auth.data,
  loading: luckyDrawWinners.loading,
  winners: Object.values(luckyDrawWinners.data),
  winnerLoading: luckyDrawWinners.winnerLoading,
})

const mapDispatch =  {
  setLoading: LuckyDrawWinnerActions.setLoading,
  setSingleClaimed: LuckyDrawWinnerActions.setSingleClaimed,
  getLuckyDrawWinners: LuckyDrawWinnerActions.getLuckyDrawWinners
}

export default connect(mapState, mapDispatch)(LuckyDrawWinners)


// WEBPACK FOOTER //
// ./src/containers/luckyDrawWinners/index.js